import { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { clearFilters, fetchSavedViews } from "redux/SingleDataset/actions";
import { useLocation, useNavigate, useParams } from "react-router";
import { SavedView } from "types";
import { State } from "redux/store";
import { getSavedViews } from "redux/SingleDataset/selectors";
import styles from "./style.module.scss";
import classNames from "classnames";
import { GoArrowRight } from "react-icons/go";
import useNavigateToView from "hooks/useNavigateToView";
import { preserveAndAppendLabelPropagationParams } from "helpers/utility/savedViewsUtils";
import { AMP_SAVED_VIEWS_EVENT__VIEW_EXPLORED } from "helpers/constants/amplitudeEvents";
import { amplitudeTrack } from "helpers/utility/amplitude";
import {
  PAGE_PARAMETER,
  SAVED_VIEW_PARAMETER,
} from "helpers/constants/miscellaneous";
import useQueryParam from "hooks/useQueryParam";
interface SavedViewsFilterProps {
  savedViews: SavedView[];
}

const SavedViewsFilter = ({ savedViews }: SavedViewsFilterProps) => {
  const { datasetId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const navigateToView = useNavigateToView();
  const location = useLocation();
  const selectedViewId = useQueryParam(SAVED_VIEW_PARAMETER);
  const selectedSavedView = savedViews.find(
    (view) => view.id === selectedViewId,
  );

  const dropdownContainerClasses = classNames(styles.dropdownContainer);
  useEffect(() => {
    dispatch(fetchSavedViews(datasetId) as any);
    //eslint-disable-next-line
  }, []);

  const handleSeeAllViewsClick = () => {
    navigate(`/dataset/${datasetId}/views`);
  };
  const handleSavedViewClick = async (savedView: SavedView) => {
    if (selectedSavedView?.id === savedView.id) {
      dispatch(clearFilters() as any);
      // Preserve page parameter and label propagation parameters when clearing saved view
      let url = `?${PAGE_PARAMETER}=1`;
      url = preserveAndAppendLabelPropagationParams(url, location.search);
      navigate({ search: url });
    } else {
      amplitudeTrack(AMP_SAVED_VIEWS_EVENT__VIEW_EXPLORED);
      navigateToView(savedView);
    }
  };

  const reorderedSavedViews = selectedSavedView
    ? [
        selectedSavedView,
        ...savedViews.filter((view) => view.id !== selectedSavedView.id),
      ]
    : savedViews;

  const renderSavedViewList = () => {
    return (
      savedViews.length > 0 && (
        <div className={dropdownContainerClasses}>
          <div className={styles.dropdownItems}>
            {reorderedSavedViews.map((savedView) => (
              <div
                className={classNames(styles.dropdownItem, {
                  [styles.selectedDropdownItem]:
                    selectedSavedView?.id === savedView.id,
                })}
                key={savedView.id}
                onClick={() => handleSavedViewClick(savedView)}
                data-selected={selectedSavedView?.id === savedView.id}
              >
                {savedView.name}
              </div>
            ))}
          </div>
          <div
            className={styles.dropdownFooter}
            onClick={handleSeeAllViewsClick}
            data-testid="see-all-views-button"
          >
            <div className={styles.dropdownFooterText}>
              {"See all views"} <GoArrowRight />
            </div>
          </div>
        </div>
      )
    );
  };

  return <>{renderSavedViewList()}</>;
};

const mapStateToProps = (state: State) => ({
  savedViews: getSavedViews(state),
});

export default connect(mapStateToProps)(SavedViewsFilter);
